import React, { useState, useRef, useEffect } from 'react';
import { MoreVertical } from 'lucide-react';

export const DropdownMenu = ({ 
  trigger, 
  options = [], 
  align = 'right' 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (e, onClick) => {
    e.stopPropagation();
    setIsOpen(false);
    if (onClick) onClick(e);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      {/* Trigger */}
      <div onClick={toggleDropdown} className="cursor-pointer inline-flex items-center justify-center p-2 rounded-full hover:bg-slate-100 transition-colors">
        {trigger ? trigger : <MoreVertical size={18} className="text-slate-500 hover:text-slate-800" />}
      </div>

      {/* Dropdown Panel */}
      {isOpen && (
        <div 
          className={`absolute z-[50] mt-2 w-48 rounded-xl bg-white/90 backdrop-blur-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] ring-1 ring-slate-900/5 focus:outline-none overflow-hidden transition-all duration-200 animate-in fade-in slide-in-from-top-2 ${
            align === 'right' ? 'right-0 origin-top-right' : 'left-0 origin-top-left'
          }`}
        >
          <div className="py-1">
            {options.map((option, idx) => {
              if (option.divider) {
                return <div key={`div-${idx}`} className="h-px bg-slate-100 my-1" />;
              }

              const Icon = option.icon;
              return (
                <button
                  key={idx}
                  onClick={(e) => handleOptionClick(e, option.onClick)}
                  disabled={option.disabled}
                  className={`group flex items-center w-full px-4 py-2.5 text-sm transition-colors
                    ${option.disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-slate-50'}
                    ${option.danger ? 'text-red-600 hover:bg-red-50' : 'text-slate-700 hover:text-slate-900'}
                  `}
                >
                  {Icon && (
                    <Icon 
                      size={16} 
                      className={`mr-3 transition-colors ${
                        option.danger 
                          ? 'text-red-500 group-hover:text-red-600' 
                          : 'text-slate-400 group-hover:text-brand-blue'
                      }`} 
                    />
                  )}
                  <span className="font-medium">{option.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};




